var _g, _rect, _g2, _g3, _path, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.96,
    y: 18.42,
    width: 304.45,
    height: 507.36,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.9 43.07 44.06 525.61 313.85 525.61 313.85 44.98 47.9 43.07",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.48,
    y: 18.42,
    width: 6.48,
    height: 507.64,
    fill: "#e3e4e5",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.11,
    y: 140.64,
    width: 266.45,
    height: 9.45,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.8,
    y: 308.49,
    width: 267.97,
    height: 9.92,
    fill: "#e3e4e5",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.45,
    y: 477.58,
    width: 269.33,
    height: 24.1,
    fill: "#e3e4e5",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.62,
    y: 324.31,
    width: 105.02,
    height: 137.14,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.31,
    y: 324.31,
    width: 105.02,
    height: 137.14,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.39,
    y1: 477.25,
    x2: 190.39,
    y2: 318.15,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6,260.08l.1-.06,1.84,16.32,28.14,249.44-69.61-.17,2.13-267.89,.1-11.4,1.61-203.26H201.75s0,146.36-118.15,217.02Z",
    fill: "#5ca0c3",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.84 263.74 88.14 277.58 85.53 276.34 46.19 257.72 46.29 246.33 83.7 260.02 93.84 263.74",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3,43.99s11.35,135.84-26.49,207.73",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,43.99s-20.43,150.48-85.52,212.53",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.35,
    y1: 267.38,
    x2: 80.73,
    y2: 525.32,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 182.76,
    y1: 450.1,
    x2: 197.14,
    y2: 450.1,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.76,
    y1: 335.88,
    x2: 197.14,
    y2: 335.88,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 303.27,
    y1: 450.1,
    x2: 314.06,
    y2: 450.1,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 303.27,
    y1: 335.88,
    x2: 314.06,
    y2: 335.88,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 357.48,
    y: 193.13,
    width: 112,
    height: 64,
    rx: 9.71,
    ry: 9.71,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M382.19,218.79v-3.34c1.22-.16,2.12-.61,2.7-1.36,.58-.75,.87-1.66,.87-2.73h-3.95v-7.34h7.43v6.77c0,2.32-.64,4.18-1.93,5.57-1.29,1.4-2.99,2.2-5.13,2.42Zm-10.87,0v-3.34c1.22-.16,2.13-.61,2.73-1.36,.6-.75,.89-1.66,.89-2.73h-3.95v-7.34h7.39v6.77c0,2.32-.63,4.18-1.9,5.57-1.27,1.4-2.99,2.2-5.15,2.42Z",
    fill: "#f7c27e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.13,
    y1: 205.77,
    x2: 398.07,
    y2: 205.77,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.13,
    y1: 215.13,
    x2: 398.07,
    y2: 215.13,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.13,
    y1: 224.48,
    x2: 372.07,
    y2: 224.48,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.13,
    y1: 233.84,
    x2: 372.07,
    y2: 233.84,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.13,
    y1: 243.2,
    x2: 372.07,
    y2: 243.2,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M594.87,168.45V19.96c0-1.88-1.53-3.41-3.41-3.41h-140.89c-1.88,0-3.41,1.53-3.41,3.41V168.45c0,1.88,1.53,3.41,3.41,3.41h61.4c9.09,22.97,44.25,30.37,44.25,30.37-17.4-10.44-19.76-23.74-19.72-30.37h54.96c1.88,0,3.41-1.53,3.41-3.41Z",
    fill: "#f7c27e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.87,19.96v14.19h-147.71v-14.19c0-1.88,1.53-3.41,3.41-3.41h140.89c1.88,0,3.41,1.53,3.41,3.41Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 452.68,
    y: 22.59,
    width: 95.95,
    height: 5.52,
    fill: "#e3e4e5",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.77,
    y: 22.59,
    width: 36.58,
    height: 5.52,
    fill: "#e3e4e5",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("rect", {
    x: 521.36,
    y: 41.05,
    width: 57.98,
    height: 52.46,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540,54.17c0,3.43-2.78,6.21-6.21,6.21-3.43,0-6.21-2.78-6.21-6.21s2.78-6.21,6.21-6.21,6.21,2.78,6.21,6.21Z",
    fill: "#f7c27e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.34,64.49v29.02h-57.98v-27.82c5.44-1.13,13.66-.75,21.4,7.81,0,0,8.97,12.42,18.64,2.07,0,0,9.79-11.1,17.95-11.07Z",
    fill: "#5ca0c3",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 458.2,
    y1: 101.8,
    x2: 515.5,
    y2: 101.8,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458.2,
    y1: 109.39,
    x2: 515.5,
    y2: 109.39,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458.2,
    y1: 116.98,
    x2: 515.5,
    y2: 116.98,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458.2,
    y1: 124.57,
    x2: 515.5,
    y2: 124.57,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458.2,
    y1: 132.17,
    x2: 515.5,
    y2: 132.17,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458.2,
    y1: 139.76,
    x2: 515.5,
    y2: 139.76,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458.2,
    y1: 147.35,
    x2: 515.5,
    y2: 147.35,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458.2,
    y1: 154.95,
    x2: 515.5,
    y2: 154.95,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458.2,
    y1: 162.54,
    x2: 515.5,
    y2: 162.54,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 526.54,
    y1: 101.8,
    x2: 583.83,
    y2: 101.8,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 526.54,
    y1: 109.39,
    x2: 583.83,
    y2: 109.39,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 526.54,
    y1: 116.98,
    x2: 583.83,
    y2: 116.98,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 526.54,
    y1: 124.57,
    x2: 583.83,
    y2: 124.57,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 526.54,
    y1: 132.17,
    x2: 583.83,
    y2: 132.17,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 526.54,
    y1: 139.76,
    x2: 583.83,
    y2: 139.76,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 526.54,
    y1: 147.35,
    x2: 583.83,
    y2: 147.35,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 526.54,
    y1: 154.95,
    x2: 583.83,
    y2: 154.95,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 526.54,
    y1: 162.54,
    x2: 583.83,
    y2: 162.54,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M497.17,54.8s-.61,.84-1.6,4.16l-2.79,10.08-3.45,12.47h-5.79l-3.45-12.47-2.3-8.33-2.3,8.33-3.45,12.47h-5.79l-3.45-12.47-2.55-9.23c-1.18-4.02-2.77-5.01-2.77-5.01h8.51s-.9,.84-.2,4.16l2.79,10.08,2.49,9.02,2.49-9.02,3.16-11.45c-.99-2.19-1.96-2.79-1.96-2.79h8.51s-.9,.84-.2,4.16l2.79,10.08,2.49,9.02,2.49-9.02,2.55-9.23c1.09-4.02,.93-5.01,.93-5.01h2.82Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M786.51,87.5h-65.57c-3.71,0-6.71,3.01-6.71,6.71v32.57c0,3.71,3.01,6.71,6.71,6.71h20.51c-.02,4.53-.96,11.71-6.22,15,0,0,15.91-1.68,21.67-15h29.61c3.71,0,6.71-3.01,6.71-6.71v-32.57c0-3.71-3.01-6.71-6.71-6.71Z",
    fill: "#5ca0c3",
    stroke: "#231f20",
    strokeMiterlimit: 10
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M742.72,110c0,1.93-1.57,3.5-3.5,3.5-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5c1.93,0,3.5,1.57,3.5,3.5Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 753.72,
    cy: 110,
    r: 3.5,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 768.22,
    cy: 110,
    r: 3.5,
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.5,379.87c1.9-9.15,9.35-16.16,18.59-18.55,13.08-3.38,34.56-2.89,52.11,26.48,0,0,16.4,25.97,6.79,63.62,0,0-1.97-19.12-32.86-32.8-3.41-1.51-6.94-2.75-10.51-3.83-9.65-2.92-38.56-13.54-34.12-34.92Z",
    fill: "#56c96e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.25,347.89c-4.18,.78-8.01,2.92-10.56,6.25-4.97,6.49-8.73,20.08,4.05,47.35,0,0,18.85,38.88-11.97,85.28,0,0,49.72-21.67,62.27-67.54,4.34-15.87,3.09-32.81-3.9-47.76-6.33-13.52-18.23-27.63-39.89-23.59Z",
    fill: "#56c96e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.44,548.91s-24.11-34.77,17.5-69.93c.94-.79,1.9-1.54,2.87-2.29,7.85-6.08,55.2-46.06,22.6-102.03",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.61,388.36s44.03,28.47,24.93,78.76c0,0-21.25,51.35,1.31,80.74",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.63,469.06c.05-5.8,3.76-10.94,9.11-13.43,7.55-3.52,20.69-5.64,34.8,10.31,0,0,12.79,13.76,11.55,37.39,0,.12-.17,.15-.22,.04-.93-2.25-5.78-11.52-23.62-15.81-2.25-.54-4.53-.9-6.83-1.16-6.19-.7-24.92-3.94-24.81-17.34Z",
    fill: "#56c96e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.11,497.48s30.1-23.44,61.78-.7c0,0,14.65,10.79,10.78,22.24-1.54,4.57-5.77,7.72-10.63,8.52-6.32,1.04-17.08,.72-28.65-8.78,0,0-25.71-19.25-33.29-21.28Z",
    fill: "#56c96e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.42,548.39s4.3-72.43,75.2-49.34",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.76 622.92 134.15 622.92 129.85 546.29 205.06 546.29 200.76 622.92",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,577.26c4.36-2.04,10.9-4.36,18.8-4.2,7.71,.16,12.58,2.59,17.74,4.2,7.42,2.31,18.56,3.88,34.37,0",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,586.7c4.36-2.04,10.9-4.36,18.8-4.2,7.71,.16,12.58,2.59,17.74,4.2,7.42,2.31,18.56,3.88,34.37,0",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.59,472.81s29.01,11.55,36.53,73.48",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "738.78 445.6 733.55 663.06 548.7 647.68 555.77 438.22 738.78 445.6",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.34,433.2c-51.93-4.17-195.22,2.53-247.57,5.03l183.01,7.38,64.57-12.07c.2-.04,.19-.32-.01-.34Z",
    fill: "#e6e7e8",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.6,
    y: 292.74,
    width: 29.53,
    height: 56.29,
    fill: "#f7c27e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.87,404.91s-23.39,5.02-27.39,22.85c0,0-5.18,21.35,27.09,18.83,.06-6.08,3.02-36.19,.3-41.68Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.67,348.72l29.22,.31,36.91,13.53c-23.84-16.95-11.94-68.07-15.38-90.73,.62-13.84,19.07-43.37,19.07-43.37,1.23-8.3,4-24.3,4-24.3-.29,.34-22.2,25.71-37.04,16.58-11.21,8.27-18.25,.28-18.25,.28-9.27,40.7,21.8,23.27-17.6,77.88l-.92,49.83Z",
    fill: "#e6e7e8",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.59,298.89s-18.53,25.22-20.34,46.91l-24.88-2.92-20.3-33.83c1.63-.55,6.1-.32,7.24-4.94,2.14-8.65,9.48-14.14,14.68-19.37,1.14-1.15,1.98-2.55,2.46-4.1,1.84-5.94,6.67-21.55,6.67-21.55,.97-6.16-3.64-12.09,4.01-19.55,0,0,12.92-14.15,12.92-14.15,0,0,10.72-12.4,19.35-15.27l11.1,22.35,1.54,9.23c13.05,20.75,.07,36.11-14.46,57.21Z",
    fill: "#f7c27e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.85,465.9c.37,3.69,39.37,81.91,33.93,84-4.16,11.12,4.98,14.32,9.44,12.27,1.23,7.38,4.61,11.07,4.61,11.07,21.89-15.03,50.07,3.59,44.31-16.52-.39-3.43-2.06-7.81-4.36-10.14-.95-.95-1.39-2.32-1.19-3.65,1.4-6.1-11.69-28.53-13.54-33.97-5.23-8.3-7.69-23.99-7.69-23.99-3.38-27.99-21.53-58.44-21.53-58.44l8.92-4.61c-3.08,6.77,3.08,18.15,3.08,18.15l118.42,4c29.22,.92,40.29-24.91,40.29-24.91,24.3-23.99-5.54-50.13-5.54-50.13l-90.12-19.99-109.19,17.22c-13.84,2.15-27.68,16.92-27.68,16.92-12.3,15.99,17.84,82.74,17.84,82.74Z",
    fill: "#5ca0c3",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.1,168.17s-6.33-1.14-9.53,.62l-1.85,4.61s9.23,11.69,16.3,13.53c0,0-.92-14.15-4.92-18.76Z",
    fill: "#e6e7e8",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.36,172.48s-8.07,8.27-7.94,8.3c0,0,5.16-.19,5.16-.19l4.62-3.8-1.85-4.31Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.44,220.73c14.84,9.13,36.75-16.23,37.04-16.58,1.18-5.55,1.45-11.55,1.54-17.22-7.38-2.15-15.07-14.76-15.07-14.76l-10.46,1.5-9.53,24.64-3.52,22.42Z",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.94,193.39c-2.14-.33,45.18,12.78,49.19,38.21,0,0-1.2,156.18-1.2,156.18,0,0,6.32,20.88,5.71,33.56-1.52,4.99-9.64,4.03-16.48,4.89,0,0-4-2.15-4.61-7.08,8.34-14.36,12.26-40.73-23.99-48.29,0,0-27.07-5.84-34.75-8.3,0,0-11.38-3.38-14.46-30.76,.77-11.65-3.84-62.17,2.48-72.92,8.81-16.6,27.83-49.87,38.12-65.49Z",
    fill: "#f7c27e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.02,334.26s3.08,7.07,3.08,22.15",
    fill: "none",
    stroke: "#ed1c24",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "696.33 329.34 694.8 329.96 704.33 360.1 719.4 359.22 723.71 355.48 719.71 346.26 696.33 329.34",
    fill: "#e6e7e8",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.99,421.31l28.3-13.84,60.12-15.79c18.74-6.97,29.99-25.63,62.61-14.35",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.22,562.18c1.23,7.38,4.61,11.07,4.61,11.07,24.92-16.67,54.74,7.76,42.07-23.65-9.62,4.3-36.54-2.47-46.69,12.57Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.83,565.11s-1.24,8.75-8.93,9.37l-21.22,1.54s-1.19-6.59-4.9-6.83c0,0,7.67-3.62,26.43-2.39,0,0,5.55,.95,8.62-1.68Z",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.69,651.99l15.38-7.69c45.08-22.34,50.79-40.88,73.51-58.13,6.32-5.42,3.51-8.48,3.38-8.61-10.77-15.07-17.16-16.54-17.16-16.54,.68,3.14-.98,4.1-.98,4.1-2.13,9.33-8.84,9.37-8.93,9.37l-21.22,1.54c-2.49-12.58-15.5-6.87-14.97,.97-.28,5.56,3.5,6.39,3.06,10.23-3.57,9.06-12.14,45.18-20.26,51.15-3.49,4.41-12.21,10.9-11.81,13.63Z",
    fill: "#f7c27e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.91,664.46c32.3-7.12,60.81-46.18,78.68-59.54,15.1-12.47,16.48-21.56,7.39-27.37,.13,.13,2.93,3.19-3.39,8.61-22.85,17.36-28.32,35.7-73.51,58.13,0,0-15.38,7.69-15.38,7.69-3.74,4.45,.39,13.78,6.21,12.48Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.4,411.77c-9.38-.17-42.25,41.27,10.46,33.83,0,0-7.38-17.53-10.46-33.83Z",
    fill: "#f7c27e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.84,426.53c1.54,1.85,6.26,11.72,6.26,11.72l4.9,.18s-5.31-10.98-2.23-16.52l-8.92,4.61Z",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.83,343.8s8-22.76,13.23-34.76c.31-19.99,.37-19.98,2.77-31.99",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.44,181.4s7.07-.31,9.53,2.77c0,0,5.84,8.3,.92,9.53,0,0-6.46,1.23-10.77-5.84-.52-.94-6.09-7.38,.31-6.46Z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.13,166.33c.67,11.33-.41,8.91,6.9,13.75,2.24,3.93,5.6,16.48,6.33,16.7-.92,5.84,4.92,6.77,4.92,6.77,.46,2.63,2.94,4.71,5.23,5.23,1.77,2.43,5.68,8.39,7.38,10.77,13.83,14.84,25.99-6.42,33.68-15.78,8.96-13.78-6.93-25.93,7.23-41.43l-25.53-25.53-47.06,18.15c-.3,3.31,.92,11.33,.92,11.38Z",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.23,154.62c7.26,5.05,18.86,2.76,40.66-4.9-5,15.69,9.27,9.89,15.69,17.22,7.1,9.85-6.23,25.98-12.92,36.29,0,0-9.53-6.15-18.45-.92,0,0-2.77,1.54-4.92,1.23,.41,2.35,2.64,4.64,5.23,5.23,25.43-13.75,22.43,19.07,4.77,6.65l-.04,.24c6.1,12.23,18.92,10.37,25.71,1.54,2.36-3.63,12.6-14.28,13.14-18.64,2.88-12.37-3.79-11.64-7.38-25.78-1.31-10.15,10.35-16.24,14.85-4,6.37-20.69-1.75-45.17-23.07-53.83,0,0-25.53-11.38-47.98,13.84,0,0-11.58,17.37-5.28,25.82Z",
    fill: "#231f20",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.81,182.63l24.61-12.92c8.52-15.21,15.26-2.95,17.81-10.89-5.9-7.1-37.32,17.61-44.27,21.04l1.85,2.77Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.64,193.87c.36,.59,5.28-.39,3.25-5.09-1.62-2.45-2.57-11.28-7.14-9.93,1.76,1.64,4.56,7.44,5.6,9.63,0,0,.51,3-1.71,5.4Z",
    fill: "#e6e7e8",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.53,167.69c-.1,10.5,11.51,10.5,11.41,0,.1-10.5-11.51-10.5-11.41,0Z",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.39,181.05c-6.25,.24,4.62,13.06,11.96,12.04,0,0,6.15,0,4-4-3.7-7.11-4.46-10.08-15.96-8.04Z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.1,168.17c9.22,11.38,2.38,44.28-.62,60.28-6.27,11-6.62,9.52-15.66,30.43,0,0,16.89-27.35,25.81-37.81,0,0,15.2-17.54,12.54-26.97-2.45-4.36-18.86-26.51-22.08-25.93Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.36,196.78c-.34-4.18,1.63-13.29-1.23-17.22",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.97,202.84s2.61-.33,3.91-3.8",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.44,180.78c-.2,0,1.29,2.58,1.24,2.64,1.58,1.41,5.57,5.99,5.45,6.28,6.52,7.91,15.31,5.5,13.21-.09,0,0-.95-2.44-.95-2.44-.61-1.47,1.52-2.62,2.42-1.32,4.67,6.44,12.08,8.15,12.08,8.15,6.93,.68,8.26-1.41,7.12-4.71-1.67-1.77-2.69-9.77-6.26-10.45-2.8-.07-8.71,.14-13.47,2.86,0,0-2.26,1.18-4,.31-2.65-1.14-6.21-1.51-8.88-1.51,0,0-7.96,.27-7.96,.27Zm31.02,.98c5.43,.32,4.96,4.07,7.11,6.86,1.72,3.19-3.19,3.19-3.19,3.19-5.39,.98-10.79-7.11-10.79-7.11-2.18-3.85,7.65-2.59,6.86-2.94Zm-15.23,2.92s4.96,7.05,.78,8.09c-2.69,.95-9.23-2.22-11.57-9.39-.07-1.87,8.2-1.53,10.79,1.3Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.25,232.17c5.82,7.96,34.3,97.9,15.74,117.16,0,0-31.37,13.23-51.98,16.92l-18.15-41.52,25.84-7.38s-6.15-24.61-.62-51.67c3.68-17.13,14.5-52.54,29.17-33.5Z",
    fill: "#f7c27e",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.7,317.35c11.37-3.35,18.61-12.15,35.37-.31",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.49,320.76c2.8,3,14.62,16.42,26.44,40.87l-18.45,6.77s-6.46-3.08-7.38-12c0,0-18.45-23.38-22.76-27.07,.77,.09,21.89-10.41,22.15-8.58Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.93,361.64s2.46,3.08-9.53,6.77l-1.61-2.7,11.15-4.06Z",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.9,205.29c-13.9,24.64,17.08,37.12,15.09,60.16,4.59-14.38-9.05-25.19-1.8-44.44-3.93-4.73-5.67-8.11-8.68-12.24-4-1.23-4.61-3.49-4.61-3.49",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "682.77 353.39 585.88 342.34 580.07 349.33 602.65 373.15 613.6 372.4 680.26 355.6 682.77 353.39",
    fill: "#e6e7e8",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.77,353.39l-73.57,17.66c-.78,.24-3.69,.08-4.52,.13l1.54,3.38c.56-.08,2.91-.24,3.39-.39,0,0,72.89-18.07,72.89-18.07l.28-2.71Z",
    fill: "#e6e7e8",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.81,376.64l-50.27-86.36-99.74-6.65c-.27-.02-.44,.27-.3,.5l49.9,79.05,100.4,13.46Z",
    fill: "#e6e7e8",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.62,376.89c1.47-.74,1.34-2.26,1.34-2.26l-49.68-83.38c-.52-.99-1.75-1.02-2.73-.97-.37,1.48,48.09,77.49,50.12,86.15,.1,.43,.57,.66,.96,.46Z",
    fill: "#231f20",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.57,335.02l2.43,3.76c1.98,2.74,18.63-.17,15.42,7.17,.34-.69,10.45-.35,7.69,5.84,1.7-.56,6.34,3.81,2.15,7.07,1.89,1.91-10.17,13.09-15.99,6.15,0,0-1.85-.92-2.46-3.08-2.65-2.32-6.6-3.22-6.15-8.3,0,0-6.15-3.08-4.92-6.46,0,0-5.85-6.49,1.84-12.16Z",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "504.41 345.95 494.56 348.72 487.8 348.1",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 512.1,
    y1: 351.79,
    x2: 493.03,
    y2: 355.79,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 514.25,
    y1: 358.87,
    x2: 499.18,
    y2: 362.56,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.23,330.71c-21.67,5.68-35.98-10.63-50.57-7.82-13.48,3.96-18.74,3.23-32.04,18.02-.69,.86-.54,2.01,.05,2.9-.67,.18-1.79,4.72,.81,5.23,1.81,.72,9.14-2.18,11.19-2.46-1.09,4.97,24.18,2.34,27.88,2.61,0,0,4.37,2.7,15.16,1.89l35.75,7.39-8.23-27.75Z",
    fill: "#faa27f",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.81,325.34l-14.69,3.6c-1.99-.17-17.62,13.69-19.45,14.85",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.43,333.03c-2.09,.37-12.45,.77-14.16,1.8,0,0-18.29,8.46-18.29,8.46-2.43,1.33-2.59,4.5,1.08,5.42",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.67,346.56c-.7-3.83,8.94-3.01,15.75-5.59,1.2-.46,8.41-.71,9.78-.87",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "738.78 445.6 804.6 433.3 801.52 618.46 733.55 663.06 738.78 445.6",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/Placeholder.e7de6cbdd2d49dfea1516cce97dec54e.svg";
export { ForwardRef as ReactComponent };